import './app.css';
import './global.css';

// Install the Auth0-aware fetch wrapper BEFORE App.svelte is evaluated, so
// any component that fires a `fetch('/api/...')` at mount time gets the
// Bearer token attached. See lib/installAuthFetch.js for the rationale —
// this is a temporary bridge until the ~80 legacy /api/proxy fetch sites
// are migrated to lib/api.js.
import { installAuthFetch } from './lib/installAuthFetch.js';
installAuthFetch();

import App from './App.svelte';

const app = new App({
  target: document.getElementById('app')
});

export default app;
